import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

interface IPower {
  key: string;
  value: number;
}

@Pipe({
  name: 'scaleFromNumber',
})
export class ScaleFromNumber implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  public transform(num: number, decimalPipeDigitsInfo = '', decimalPipeLocale = ''): string {
    if (num === undefined || num === null || isNaN(num)) return '';
    let exp: number;
    const baseScaleValue: number = 1000;
    const powers: IPower[] = [
      {key: 'K', value: Math.pow(10, 3)},
      {key: 'M', value: Math.pow(10, 6)},
      {key: 'B', value: Math.pow(10, 9)},
      {key: 'T', value: Math.pow(10, 12)},
      {key: 'Q', value: Math.pow(10, 15)},
    ];
    if (num < baseScaleValue) return this.decimalPipe.transform(num, decimalPipeDigitsInfo, decimalPipeLocale);
    exp = Math.floor(Math.log(num) / Math.log(baseScaleValue));
    const suffixKey: string = powers[exp - 1]['key'];
    const suffixValue: number = powers[exp - 1]['value'];
    const transformedNum: string = this.decimalPipe.transform(num / suffixValue, decimalPipeDigitsInfo, decimalPipeLocale);
    return transformedNum + suffixKey;
  }
}
